var _style, _path, _g, _rect, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLdc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.6 53.6",
    style: {
      enableBackground: "new 0 0 56.6 53.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#080073;stroke-miterlimit:10;}\r\n\t.st1{fill:#080073;}\r\n\t.st2{fill:#32C5F4;}\r\n\t.st3{fill:none;}\r\n\t.st4{enable-background:new    ;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.6,1h35.6c5,0,9,4,9,9v32.9c0,5-4,9-9,9H10.6c-5,0-9-4-9-9V10C1.6,5,5.7,1,10.6,1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.7,4.2c-7.7,0-14,6.3-14,14s6.3,14,14,14c2.8,0,5.4-0.9,7.6-2.3v-0.1l3.6-3.6c0.3-0.2,0.5-0.4,0.7-0.6 c1.3-2.1,2.1-4.7,2.1-7.4C34.6,10.4,28.4,4.2,20.7,4.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42,5.6c-0.6-0.3-1.2-0.5-1.8-0.7L22.7,22.4c0.2,0.6,0.5,1.2,0.7,1.8L42,5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.5,14.4l9.7-9.7C27.5,6,23.8,9.7,22.5,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36,4.2c-0.1,0-0.2,0-0.3,0L22,17.8c0,0.1,0,0.2,0,0.3c0,0.7,0.1,1.4,0.2,2.1L38.1,4.3 C37.4,4.2,36.7,4.2,36,4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.9,18.1c0-0.7-0.1-1.3-0.2-1.9L34,31.9c0.6,0.1,1.3,0.2,1.9,0.2c0.2,0,0.3,0,0.5,0l13.4-13.4 C49.9,18.5,49.9,18.3,49.9,18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.3,14c-0.2-0.6-0.4-1.3-0.7-1.8L30,30.7c0.6,0.3,1.2,0.5,1.8,0.7L49.3,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.2,7.7c-0.5-0.4-0.9-0.8-1.4-1.1L24.4,25.9c0.3,0.5,0.7,1,1.1,1.4L45.2,7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.4,21.9l-9.7,9.7C44.4,30.2,48.1,26.6,49.4,21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.6,10.5c-0.3-0.5-0.7-1-1.1-1.5L26.8,28.7c0.5,0.4,0.9,0.8,1.5,1.1L47.6,10.5z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 35.1,
    className: "st3",
    width: 42.9,
    height: 18.4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11,35.8H13V45h6.2v1.3H11V35.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.1,36.4c1.1,0.5,2,1.1,2.6,1.9s1,1.7,1,2.7s-0.3,1.9-1,2.7c-0.6,0.8-1.5,1.4-2.6,1.9 c-1.1,0.5-2.4,0.7-3.8,0.7h-5.7V35.8h5.8C28.8,35.8,30,36,31.1,36.4z M30.1,44.4c0.8-0.3,1.4-0.8,1.9-1.4s0.7-1.3,0.7-2 c0-0.8-0.2-1.4-0.7-2s-1.1-1.1-1.9-1.4c-0.8-0.3-1.7-0.5-2.7-0.5h-3.8V45h3.9C28.4,45,29.3,44.8,30.1,44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.4,37.3c-0.7-0.2-1.5-0.4-2.2-0.4c-1,0-1.9,0.2-2.8,0.5c-0.8,0.4-1.5,0.8-2,1.5c-0.5,0.6-0.7,1.3-0.7,2 c0,0.7,0.2,1.4,0.7,2c0.5,0.6,1.1,1.1,2,1.5c0.8,0.4,1.8,0.5,2.8,0.5c0.7,0,1.5-0.1,2.2-0.3s1.4-0.5,1.9-0.9l1.2,0.9 c-0.7,0.5-1.5,0.9-2.5,1.2s-1.9,0.4-2.9,0.4c-1.3,0-2.6-0.2-3.7-0.7c-1.1-0.5-2-1.1-2.7-1.9c-0.6-0.8-1-1.7-1-2.7 c0-1,0.3-1.9,1-2.7s1.5-1.5,2.7-1.9c1.1-0.5,2.4-0.7,3.7-0.7c1,0,1.9,0.1,2.9,0.4c0.9,0.3,1.7,0.7,2.4,1.2l-1.2,1 C46.8,37.9,46.1,37.5,45.4,37.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLdc);
export default __webpack_public_path__ + "static/media/ldc.05803ab7e2f44a851cf2004c24deb933.svg";
export { ForwardRef as ReactComponent };